import React from "react";
import Banner from "../../Componentes/Banner/Banner";
import Confirmacion from "../../Componentes/Confirmacion/Confirmacion";
import Dresscode from "../../Componentes/Dresscode/Dresscode";
//import Fotos from "../../Componentes/Fotos/Fotos";
import Frase from "../../Componentes/Frase/Frase";
//import Hospedaje from "../../Componentes/Hospedaje/Hospedaje";
//import Itinerario from "../../Componentes/Itinerario/Itinerario";
import Regalos from "../../Componentes/Regalos/Regalos";
import Ubicacion from "../../Componentes/Ubicacion/Ubicacion";
import Reproductor from "../../Componentes/Reproductor/Reproductor"
import CuentaRegresiva from '../../Componentes/CuentaRegresiva/CuentaRegresiva';
import Pdf from "../../Componentes/Pdf/Pdf"
import AgregarMusica from "../../Componentes/AgregarMusica/AgregarMusica";
import Notas from "../../Componentes/Notas/Notas";
import Instagram from "../../Componentes/Instagram/Instagram";

function App({ tipo }) {
  return (
    <div>
     <body>
      <Banner />
    <div> 
      <Reproductor/>
    </div> 
    <main>
      <div>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/> 
      </div>
      <section>
           <CuentaRegresiva/>
        </section>
        <section >
        <Frase/>
        </section > 
       <section >
       <div><Ubicacion/></div> 
      { /* <div><Itinerario/></div>*/}
      <div><Confirmacion tipo={tipo} /></div>
        </section>
        <section >
       {/* <Fotos/>*/}
        </section >
        <section >
        {  /*<Hospedaje/>*/}
       
          
           <AgregarMusica/>
           <Notas/>
         <Dresscode/>
           <Instagram/>
        < Regalos/>
       < Pdf/>
        </section >
    </main>
   
  </body>
     
    </div>
  );
}

export default App;

